import { render } from "./RulesModal.vue?vue&type=template&id=2b70936d&scoped=true"
import script from "./RulesModal.vue?vue&type=script&lang=js"
export * from "./RulesModal.vue?vue&type=script&lang=js"

import "./RulesModal.vue?vue&type=style&index=0&id=2b70936d&scoped=true&lang=scss"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b70936d"]])

export default __exports__